import React from 'react';
import { useParams } from 'react-router-dom';
import { routes } from '../../routes';
import { CompensationReviewsList } from './CompensationReviewsList';
import { CompensationReviewDetail } from './CompensationReviewDetail';

// Compensation Reviews rendered as a subtab under Team -> People. Reuses the
// same body components as the standalone page (no duplication); only the
// navigation targets differ.

export const CompensationReviewsSubtab: React.FC<
  React.PropsWithChildren<unknown>
> = () => (
  <CompensationReviewsList
    buildDetailUrl={(id) =>
      routes.myTeamCompensationReview.route.create({ id })
    }
  />
);

export const CompensationReviewSubtabDetail: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { id } = useParams<{ id: string }>();
  return (
    <CompensationReviewDetail
      id={id}
      listUrl={routes.myTeamCompensationReviews.route.create({})}
      buildDetailUrl={(reviewId) =>
        routes.myTeamCompensationReview.route.create({ id: reviewId })
      }
    />
  );
};
